var customCodFormProvinces = {
        data: {
  "AHUACHAPÁN": {
    "AHUACHAPÁN": {
      "Area Urbana": true,
      "Ashapuco": true,
      "Chancuyo": true,
      "Chipilapa": true,
      "Cuyanausul": true,
      "El Anonal": true,
      "El Barro": true,
      "El Junquillo": true,
      "El Roble": true,
      "El Tigre": true,
      "La Coyotera": true,
      "La Danta": true,
      "La Montañita": true,
      "Las Chinamas": true,
      "Llano de Doña María": true,
      "Llano de la Laguna": true,
      "Loma de la Gloria": true,
      "Los Huatales": true,
      "Los Magueyes": true,
      "Los Toles": true,
      "Palo Pique": true,
      "Río Frío": true,
      "San Lázaro": true,
      "San Ramón": true,
      "Santa Cruz": true,
      "Santa Rosa Acacalco": true,
      "Suntecumat": true,
      "Tacubita": true
    },
    "APANECA": {
      "Area Urbana": true,
      "El Saitillal": true,
      "Palo Verde": true,
      "Quezalapa": true,
      "San Ramoncito": true,
      "Taltapanca": true,
      "Tizapa": true,
      "Tulapa": true
    },
    "ATIQUIZAYA": {
      "Area Urbana": true,
      "El Chayal": true,
      "El Salitrero": true,
      "El Tapacún": true,
      "El Tortuguero": true,
      "Izcaquilio": true,
      "Joya del Platanar": true,
      "Joya del Zapote": true,
      "La Esperanza": true,
      "Loma de Alarcón": true,
      "Pepenance": true,
      "Rincón Grande": true,
      "San Juan": true,
      "Santa Rita": true,
      "Zunca": true
    },
    "CONCEPCIÓN DE ATACO": {
      "Area Urbana": true,
      "El Arco": true,
      "El Carrizal": true,
      "El Limo": true,
      "El Molino": true,
      "El Naranjito": true,
      "El Tronconal": true,
      "La Ceiba": true,
      "La Joya de los Apantes": true,
      "Los Tablones": true,
      "San José": true,
      "Shucutitan": true,
      "Texusin Chirizo": true
    },
    "EL REFUGIO": {
      "Area Urbana": true,
      "Comapa": true,
      "El Rosario": true,
      "San Antonio": true,
      "San Juan": true
    },
    "GUAYMANGO": {
      "Area Urbana": true,
      "Cauta Abajo": true,
      "Cauta Arriba": true,
      "El Carmen": true,
      "El Escalón": true,
      "El Rosario": true,
      "El Zarzal": true,
      "Iztagapan": true,
      "La Esperanza": true,
      "La Paz": true,
      "Los Platanares": true,
      "Los Puentecitos": true,
      "Morro Grande": true,
      "San Andrés": true,
      "San Martín": true
    },
    "JUJUTLA": {
      "Area Urbana": true,
      "Barra de Santiago": true,
      "El Diamante": true,
      "Faya": true,
      "Guayapa Abajo": true,
      "Guayapa Arriba": true,
      "Las Mesas": true,
      "Los Amates": true,
      "Rosario Abajo": true,
      "Rosario Arriba": true,
      "San Antonio": true,
      "San José el Naranjo": true,
      "Tihuicha": true,
      "Zapúa": true
    },
    "SAN FRANCISCO MENÉNDEZ": {
      "Agua Fría": true,
      "Area Urbana": true,
      "Cara Sucia": true,
      "El Corozo": true,
      "El Jocotillo": true,
      "El Sacramento": true,
      "El Zapote": true,
      "Garita Palmera": true,
      "La Ceiba": true,
      "La Hachadura": true,
      "San Benito": true
    },
    "SAN LORENZO": {
      "Area Urbana": true,
      "El Conacaste": true,
      "El Jicaral": true,
      "El Portillo": true,
      "La Guascota": true,
      "Las Pozas": true,
      "San Juan Buena Vista": true
    },
    "SAN PEDRO PUXTLA": {
      "Area Urbana": true,
      "El Cortez": true,
      "El Durazno": true,
      "Guachipilín": true,
      "La Concepción": true,
      "Pululapa": true,
      "Texispulco": true
    },
    "TACUBA": {
      "Agua Fría": true,
      "Area Urbana": true,
      "El Chaguite": true,
      "El Jícaro": true,
      "El Níspero": true,
      "El Rodeo": true,
      "El Rosario": true,
      "El Sincuyo": true,
      "La Montaña": true,
      "La Pandeadura": true,
      "La Puerta": true,
      "Loma Larga": true,
      "Monte Hermoso": true,
      "San Juan": true,
      "San Rafael": true
    },
    "TURÍN": {
      "Area Urbana": true,
      "El Jobo": true,
      "El Paraíso": true,
      "Santa Rita": true
    }
  },
  "CABAÑAS": {
    "CINQUERA": {
      "Area Urbana": true,
      "Dulce Nombre o la Escopeta": true,
      "El Cacao": true,
      "El Pepeto": true,
      "Huilihuiste": true,
      "San Antonio": true,
      "San Benito": true,
      "San José el Tule": true,
      "San Nicolás": true,
      "Valle Nuevo": true
    },
    "DOLORES": {
      "Area Urbana": true,
      "Cañafístula": true,
      "Chapelcoro": true,
      "Curaren": true,
      "El Rincón": true,
      "Niqueresque": true,
      "San Carlos": true
    },
    "GUACOTECTI": {
      "Agua Zarca": true,
      "Area Urbana": true,
      "El Bañadero": true,
      "Pie de la Cuesta": true,
      "Tempisque Abajo": true
    },
    "ILOBASCO": {
      "Agua Zarca": true,
      "Area Urbana": true,
      "Azacualpa": true,
      "Cerro Colorado": true,
      "La Labor": true,
      "Las Huertas": true,
      "Los Hoyos": true,
      "Los Llanitos": true,
      "Maquilishuat": true,
      "Nanastepeque": true,
      "Oratorio": true,
      "Potrero": true,
      "San Francisco Iraheta": true,
      "San Francisco del Monte": true,
      "San José": true,
      "San José Calera": true,
      "Santa Cruz": true,
      "Sitio Viejo": true
    },
    "JUTIAPA": {
      "Area Urbana": true,
      "Caleras": true,
      "Carolina": true,
      "El Mestizo": true,
      "El Platanar": true,
      "Llano Largo": true,
      "Palacios": true,
      "San Sebastián": true,
      "Santa Bárbara": true
    },
    "SAN ISIDRO": {
      "Area Urbana": true,
      "El Amate": true,
      "Izcatal": true,
      "Llano de la Hacienda": true,
      "Los Jobos": true,
      "Potrero de Batres": true,
      "Potrero y Tabla": true,
      "San Francisco": true
    },
    "SENSUNTEPEQUE": {
      "Area Urbana": true,
      "Chunte": true,
      "Copinolapa": true,
      "Cunchique": true,
      "Cuyantepeque": true,
      "El Aguacate": true,
      "El Volcán": true,
      "La Trinidad": true,
      "Las Marías": true,
      "Llano Grande": true,
      "Los Llanitos": true,
      "Nombre de Dios": true,
      "Pie de la Cuesta": true,
      "Rojas": true,
      "Río Grande": true,
      "San Gregorio": true,
      "San Lorenzo": true,
      "San Marcos": true,
      "San Matías": true,
      "San Nicolás": true,
      "Santa Rosa": true,
      "Tronalagua": true
    },
    "TEJUTEPEQUE": {
      "Area Urbana": true,
      "Concepción": true,
      "El Zapote": true,
      "San Antonio Buena vista": true,
      "San Francisco Echeverría": true,
      "Santa Olaya": true,
      "Santa Rita": true
    },
    "VICTORIA": {
      "Area Urbana": true,
      "Azacualpa": true,
      "El Caracol": true,
      "El Zapote": true,
      "La Bermuda": true,
      "La Uvilla": true,
      "Paratao": true,
      "Peña Blanca": true,
      "Rojitas": true,
      "San Antonio": true,
      "San Pedro": true,
      "Santa Marta": true
    }
  },
  "CHALATENANGO": {
    "AGUA CALIENTE": {
      "Agua Fría": true,
      "Agua Zarca": true,
      "Area Urbana": true,
      "Cerro Grande": true,
      "Encumbrado": true,
      "Obrajuelo": true,
      "Ojos De Agua": true,
      "Santa Rosa": true
    },
    "ARCATAO": {
      "Area Urbana": true,
      "Cerro Grande": true,
      "Las Vegas": true,
      "Los Filos": true,
      "Los Sitios": true,
      "Teosinte": true
    },
    "AZACUALPA": {
      "Area Urbana": true,
      "Cuesta Marina": true,
      "El Llano": true
    },
    "CHALATENANGO": {
      "Area Urbana": true,
      "Chiapas": true,
      "Guarjila": true,
      "Las Minas": true,
      "San Bartolo": true,
      "San José": true,
      "Upatoro": true
    },
    "CITALÁ": {
      "Area Urbana": true,
      "El Rosario": true,
      "Gualcho": true,
      "Lagunetas": true,
      "Llano de la Virgen": true,
      "Los Planes": true,
      "San Francisco": true,
      "San Lorenzo": true,
      "San Ramón": true,
      "Talquezalar": true
    },
    "COMALAPA": {
      "Area Urbana": true,
      "Candelaria": true,
      "El Morro": true,
      "Guachipilín": true,
      "La Junta": true,
      "Los Achotes": true
    },
    "CONCEPCIÓN QUEZALTEPEQUE": {
      "Area Urbana": true,
      "El Conacaste": true,
      "El Rosario": true,
      "Llano Grande": true,
      "Monte Redondo": true,
      "Olosingo": true
    },
    "DULCE NOMBRE DE MARÍA": {
      "Area Urbana": true,
      "Chorro Blanco": true,
      "Cuevitas": true,
      "El Común": true,
      "El Ocotal": true,
      "El Rosario": true,
      "Los Achiotes": true,
      "Los Encuentros": true,
      "Los Gutiérrez": true,
      "Los Sitios": true
    },
    "EL CARRIZAL": {
      "Area Urbana": true,
      "La Trinidad": true,
      "La cuchilla": true,
      "Petapa": true,
      "Potrerillos": true,
      "Vainillas": true
    },
    "EL PARAISO": {
      "Area Urbana": true,
      "El Tablón": true,
      "Santa Bárbara": true,
      "Valle Nuevo": true
    },
    "LA LAGUNA": {
      "Area Urbana": true,
      "La Cuchilla": true,
      "Las Pacayas": true,
      "Los Prados": true,
      "Plan Verde": true,
      "San José": true
    },
    "LA PALMA": {
      "Area Urbana": true,
      "El Aguacatal": true,
      "El Gramal": true,
      "El Túnel": true,
      "Las Granadillas": true,
      "Los Horcones": true,
      "Los Planes": true,
      "San José Calera": true,
      "San José Sacare": true
    },
    "LA REINA": {
      "Area Urbana": true,
      "El Pepeto": true,
      "El Tigre": true,
      "Las Cañas": true,
      "Los Tecomates": true,
      "Talchaluya": true,
      "Tilapa": true
    },
    "LAS VUELTAS": {
      "Area Urbana": true,
      "Conacaste": true,
      "La Ceiba": true,
      "La Laguna": true,
      "Los Naranjos": true,
      "San José": true,
      "Sicahuite": true
    },
    "NOMBRE DE JESÚS": {
      "Area Urbana": true,
      "Los Escalante": true,
      "Los Henríquez": true,
      "Patamera": true,
      "Plazuelas": true,
      "Potrerillos": true,
      "Quipure": true
    },
    "NUEVA CONCEPCIÓN": {
      "Area Urbana": true,
      "Chilamates": true,
      "El Gavilán": true,
      "El Zapote": true,
      "Laguna Seca": true,
      "Las Tablas": true,
      "Potenciana": true,
      "Potrero Sula": true,
      "Santa Rita Cimarrón": true,
      "Santa Rosa": true,
      "Sunapa": true
    },
    "NUEVA TRINIDAD": {
      "Area Urbana": true,
      "Carasque": true,
      "El Sitio": true,
      "El Zacamil": true,
      "Huizúcar": true,
      "Jaguatalla": true,
      "Las Vegas": true
    },
    "OJOS DE AGUA": {
      "Area Urbana": true,
      "Coyolar": true,
      "El Portillo": true,
      "El Sitio": true,
      "El Tablón": true,
      "El Zapotal": true,
      "La Montañita": true,
      "Yurique": true
    },
    "POTONICO": {
      "Area Urbana": true,
      "Corral Falso": true,
      "La Montaña": true,
      "Monte Redondo": true,
      "Plan de las Pozas": true,
      "Santa Teresa": true
    },
    "SAN ANTONIO DE LA CRUZ": {
      "Area Urbana": true,
      "Copalío": true,
      "El Zapote": true,
      "San Benito": true,
      "Santa Ana": true
    },
    "SAN ANTONIO LOS RANCHOS": {
      "Area Urbana": true,
      "El Gramal": true
    },
    "SAN FERNANDO": {
      "Area Urbana": true,
      "Jocotán": true,
      "Los Llanitos": true,
      "Nuevo San Fernando Roblar": true,
      "San Juan de la Cruz": true,
      "Valle de Jesús": true
    },
    "SAN FRANCISCO LEMPA": {
      "Area Urbana": true,
      "Los Menjívar": true,
      "Los Zepeda": true
    },
    "SAN FRANCISCO MORAZÁN": {
      "Area Urbana": true,
      "Higueral": true,
      "Las Cañitas": true,
      "Las Parvitas": true,
      "Los Naranjos": true,
      "Plan del Horno": true,
      "Río Grande de Alvarado": true,
      "San Miguelito": true,
      "Sumpul de Avelar": true,
      "Sumpul de Chacón": true,
      "Teosinte": true,
      "Tremedal": true
    },
    "SAN IGNACIO": {
      "Area Urbana": true,
      "El Carmen": true,
      "El Centro": true,
      "El Pinar": true,
      "El Rosario": true,
      "Las Pilas": true,
      "Río Chiquito": true,
      "Santa Rosa": true
    },
    "SAN ISIDRO LABRADOR": {
      "Alvarenga": true,
      "Area Urbana": true,
      "El Mojón": true,
      "El Sicahuital": true,
      "Los Amates": true,
      "San José de la Montaña": true
    },
    "SAN JOSÉ CANCASQUE": {
      "Area Urbana": true,
      "Candelaria": true,
      "Concepción": true,
      "Los Guillén": true,
      "Portillo del Norte": true
    },
    "SAN JOSÉ LAS FLORES": {
      "Aldea Vieja": true,
      "Area Urbana": true,
      "Hacienda": true,
      "Hacienda Vieja": true,
      "Lagunita": true,
      "Las Limas": true,
      "Llano Verde": true
    },
    "SAN LUIS DEL CARMEN": {
      "Area Urbana": true,
      "El Pital": true,
      "El Sitio": true,
      "Los Naranjos": true,
      "Santa Cruz": true
    },
    "SAN MIGUEL DE MERCEDES": {
      "Area Urbana": true,
      "Cerro de la Cruz": true,
      "El Matazano": true,
      "El Salitre": true,
      "Los Guardado": true,
      "Piedras Gordas": true
    },
    "SAN RAFAEL": {
      "Area Urbana": true,
      "Los Desamparados": true,
      "Ojos de Agua": true,
      "San Antonio Buena Vista": true,
      "San José los Sitios": true
    },
    "SANTA RITA": {
      "Area Urbana": true,
      "Barillas": true,
      "El Chilamate": true,
      "San Miguel Tobías": true,
      "San Nicolás Piedras Gordas": true
    },
    "TEJUTLA": {
      "Aguaje Escondido": true,
      "Aldeita": true,
      "Area Urbana": true,
      "Concepción": true,
      "El Carrizal": true,
      "El Cerrón": true,
      "El Izotal": true,
      "El Salitre": true,
      "El Tránsito": true,
      "Estanzuelas": true,
      "Los Aposentos": true,
      "Los Martínez": true,
      "Quitasol": true,
      "Río Grande de Alvarado": true,
      "Río Grande de Cardoza": true,
      "San José": true
    }
  },
  "CUSCATLÁN": {
    "CANDELARIA": {
      "Area Urbana": true,
      "Concepción": true,
      "El Rosario": true,
      "La Palma": true,
      "Nance Verde": true,
      "San Antonio": true,
      "San José la Ceiba": true,
      "San Juan Miraflores Abajo": true,
      "San Juan Miraflores Arriba": true,
      "San Rafael La Loma": true
    },
    "COJUTEPEQUE": {
      "Area Urbana": true,
      "Cujuapa": true,
      "El Carrizal": true,
      "Jiñuco": true,
      "La Palma": true,
      "Los Naranjos": true,
      "Ojos de Agua": true
    },
    "EL CARMEN": {
      "Area Urbana": true,
      "Candelaria": true,
      "Concepción": true,
      "El Carmen": true,
      "La Paz": true,
      "San Sebastián": true,
      "Santa Lucía": true
    },
    "EL ROSARIO": {
      "Area Urbana": true,
      "El Amatillo": true,
      "El Calvario": true,
      "San Martín": true,
      "Veracruz": true
    },
    "MONTE SAN JUAN": {
      "Area Urbana": true,
      "Candelaria": true,
      "Concepción": true,
      "El Carmen": true,
      "El Rosario": true,
      "La Soledad": true,
      "San Andrés": true,
      "San Antonio": true,
      "San José": true,
      "San Martín": true,
      "San Nicolás": true
    },
    "ORATORIO DE CONCEPCIÓN": {
      "Area Urbana": true,
      "Palacios": true,
      "Tacanagua": true
    },
    "SAN BARTOLOME PERULAPÍA": {
      "Area Urbana": true,
      "El Triunfo": true,
      "Las Lomas": true
    },
    "SAN CRISTOBAL": {
      "Area Urbana": true,
      "La Virgen": true,
      "San Antonio": true,
      "San Francisco": true,
      "San José": true,
      "Santa Anita": true,
      "Santa Cruz": true
    },
    "SAN JOSÉ GUAYABAL": {
      "Animas": true,
      "Area Urbana": true,
      "El Salitre": true,
      "La Cruz": true,
      "Llano Grande": true,
      "Los Meléndez": true,
      "Los Rodríguez": true,
      "Montepeque": true,
      "Palacios": true,
      "Piedra Labrada": true,
      "Ramírez": true
    },
    "SAN PEDRO PERULAPAN": {
      "Area Urbana": true,
      "Buena Vista": true,
      "Buenos Aires": true,
      "El Carmen": true,
      "El Espino": true,
      "El Limón": true,
      "El Paraíso": true,
      "El Rodeo": true,
      "Huisiltepeque": true,
      "Istagua": true,
      "La Cruz": true,
      "La Esperanza": true,
      "La Loma": true,
      "Miraflores": true,
      "San Agustín": true,
      "San Francisco": true,
      "Tecoluco": true,
      "Tecomatepe": true
    },
    "SAN RAFAEL CEDROS": {
      "Area Urbana": true,
      "Cerro Colorado": true,
      "Copinol": true,
      "El Espinal": true,
      "Jiboa": true,
      "Palacios": true
    },
    "SAN RAMON": {
      "Area Urbana": true,
      "San Agustín": true,
      "San Pablo": true,
      "San Pedro": true,
      "Santa Isabel": true
    },
    "SANTA CRUZ ANALQUITO": {
      "Area Urbana": true,
      "Barrio Abajo": true
    },
    "SANTA CRUZ MICHAPA": {
      "Area Urbana": true,
      "Buena Vista": true,
      "Delicias": true,
      "El Centro": true,
      "Jiñuco": true,
      "Michapa": true,
      "Rosales": true,
      "Ánimas": true
    },
    "SUCHITOTO": {
      "Aguacayo": true,
      "Area Urbana": true,
      "Buena Vista": true,
      "Colima": true,
      "Consolación": true,
      "Copapayo": true,
      "Corozal": true,
      "El Caulote": true,
      "El Molino": true,
      "El Roble": true,
      "El Zapote": true,
      "Estanzuelas": true,
      "Guadalupe": true,
      "Haciendita": true,
      "Ichanquezo": true,
      "La Bermuda": true,
      "Las Delicias": true,
      "Milingo": true,
      "Mirandilla": true,
      "Montepeque": true,
      "Palo Grande": true,
      "Pepeshtenango": true,
      "San Cristóbal": true,
      "Tenango": true
    },
    "TENANCINGO": {
      "Ajuluco": true,
      "Area Urbana": true,
      "Copalchan": true,
      "Corral Viejo": true,
      "El Pepeto": true,
      "Huisiltepeque": true,
      "Jiñuco": true,
      "Rosario Perico": true,
      "Rosario Tablón": true,
      "Santa Anita": true
    }
  },
  "LA LIBERTAD": {
    "ANTIGUO CUSCATLÁN": {
      "Area Urbana": true,
      "El Espino": true,
      "La Labranza": true
    },
    "CHILTIUPÁN": {
      "Area Urbana": true,
      "Cuervo Abajo": true,
      "Cuervo Arriba": true,
      "El Regadillo": true,
      "El Zonte": true,
      "Juan Higinio o La Cumbre": true,
      "Julupe": true,
      "La Perla": true,
      "Las Flores": true,
      "Santa Lucía": true,
      "Santa Marta": true,
      "Siberia": true,
      "Sunzacuapa": true,
      "Taquillo": true,
      "Termopilas": true
    },
    "CIUDAD ARCE": {
      "Area Urbana": true,
      "El Conacaste": true,
      "Flor Amarilla": true,
      "La Esperanza": true,
      "La Reforma": true,
      "Las Cruces": true,
      "Lomas de Andalucía": true,
      "Los Acostas": true,
      "San Andrés": true,
      "San Antonio Abad": true,
      "Santa Lucía": true,
      "Santa Rosa": true,
      "Veracruz": true,
      "Zapotitán": true
    },
    "COLÓN": {
      "Area Urbana": true,
      "Botoncillal": true,
      "El Capulín": true,
      "El Cobanal": true,
      "El Manguito": true,
      "Entre Ríos": true,
      "Las Angosturas": true,
      "Las Brisas": true,
      "Las Delicias": true,
      "Lourdes": true,
      "San José los Sitios": true,
      "Victoria": true
    },
    "COMASAGUA": {
      "Area Urbana": true,
      "El Conacaste": true,
      "El Faro": true,
      "El Majahual": true,
      "El Matazano": true,
      "El Peñón": true,
      "El Rosario": true,
      "La Shila": true,
      "Los Amates": true,
      "San Antonio": true,
      "Santa Lucía": true,
      "Tarpeya": true
    },
    "HUIZUCAR": {
      "Amaquilco": true,
      "Amulunca": true,
      "Area Urbana": true,
      "El Cedro": true,
      "La Lima": true,
      "Nazareth": true,
      "Ojos de Agua": true,
      "San Juan Buena Vista": true,
      "Tilapa": true
    },
    "JAYAQUE": {
      "Area Urbana": true,
      "Juan Higinio o la Cumbre": true,
      "La Labor": true,
      "Las Flores": true,
      "Las Minas": true,
      "Las Tinieblas": true,
      "Los Alpes": true,
      "San José los Sitios": true
    },
    "JICALAPA": {
      "Area Urbana": true,
      "Candelaria": true,
      "El Angel": true,
      "El Carrizo": true,
      "El Níspero": true,
      "La Argentina": true,
      "La Perla": true,
      "Metayo": true,
      "San Isidro": true,
      "San José el Tablón": true,
      "Santa Lucía": true
    },
    "LA LIBERTAD": {
      "Area Urbana": true,
      "Cangrejera": true,
      "El Cimarrón": true,
      "El Majahual": true,
      "El Palomar": true,
      "El Rosario": true,
      "Melara": true,
      "San Diego": true,
      "San Juan Buena Vista": true,
      "San Rafael": true,
      "Tecualuya": true
    },
    "NUEVO CUSCATLÁN": {
      "Area Urbana": true,
      "Florencia": true,
      "Resto de Area Rural": true
    },
    "QUEZALTEPEQUE": {
      "Area Urbana": true,
      "El Matazano": true,
      "El Puente": true,
      "El Señor": true,
      "Girón": true,
      "Las Granadillas": true,
      "Las Mercedes": true,
      "Macance": true,
      "Platanillos": true,
      "Primavera": true,
      "San Francisco": true,
      "San Juan los Planes": true,
      "Segura": true,
      "Sitio los Nejapa": true,
      "Tacachico": true
    },
    "SACACOYO": {
      "Area Urbana": true,
      "Ateos": true,
      "Buena Vista": true,
      "El Tigre": true,
      "El Tránsito": true,
      "La Montañita": true,
      "Lomas de Cerna": true,
      "San Antonio": true,
      "Tres Ceibas": true,
      "Zapotitan": true
    },
    "SAN JUAN OPICO": {
      "Agua Escondida": true,
      "Area Urbana": true,
      "Barranca Honda": true,
      "Buena Vista": true,
      "Chanmico": true,
      "Chantusnene": true,
      "El Carmen": true,
      "El Castillo": true,
      "El Jabalí": true,
      "El Matazano": true,
      "Flor Amarilla": true,
      "Joya de Cerén": true,
      "La Nueva Encarnación": true,
      "La puebla": true,
      "Las Delicias": true,
      "Las Granadillas": true,
      "Lomas de Santiago": true,
      "Los Amates": true,
      "Minas de Plomo": true,
      "Moncagua": true,
      "Nombre de Dios": true,
      "Pitichorro": true,
      "Primavera": true,
      "Resto De Área Rural": true,
      "San Antonio": true,
      "San Antonio Tehuicho": true,
      "San Felipe": true,
      "San José la Cueva": true,
      "San Nicolás Encarnación": true,
      "San Nicolás los Encuentros": true,
      "San Pedro Mártir": true,
      "San Pedro Oriente": true,
      "Sitio Grande": true,
      "Sitio Roma": true,
      "Sitio del Niño": true
    },
    "SAN MATÍAS": {
      "Area Urbana": true,
      "El Jocote": true,
      "El Jícaro": true,
      "La Puebla": true,
      "Las Anonas": true,
      "Masajapa": true,
      "San Pedro las Flores": true,
      "Santa Rosa": true,
      "Santa Teresa": true
    },
    "SAN PABLO TACACHICO": {
      "Area Urbana": true,
      "Atiocoyo": true,
      "Campana": true,
      "El Tránsito": true,
      "Las Anonas": true,
      "Las Mesas": true,
      "Mogotes": true,
      "Moncagua": true,
      "Obraje Nuevo": true,
      "San Isidro": true,
      "San Pedro Las Flores": true
    },
    "SANTA TECLA": {
      "Area Urbana": true,
      "Ayagualo": true,
      "Buena Vista": true,
      "El Cobanal": true,
      "El Limón": true,
      "El Matazano": true,
      "El Progreso": true,
      "El Quequeishque": true,
      "El Sacazil": true,
      "El Triunfo": true,
      "Las Granadillas": true,
      "Loma Larga": true,
      "Los Amates": true,
      "Los Pajales": true,
      "Victoria": true,
      "Álvarez": true
    },
    "San José Villanueva": {
      "Area Urbana": true,
      "El Escalón": true,
      "El Matazano": true,
      "El Palomar": true,
      "Las Dispensas": true,
      "Tula": true
    },
    "TALNIQUE": {
      "Area Urbana": true,
      "Juan Higinio o La Cumbre": true,
      "Las Quebradas": true,
      "Loma Larga": true,
      "Los Amates": true,
      "Los Cipreses": true,
      "Los Laureles": true,
      "San Carlos": true,
      "San José los Sitios": true,
      "Santa Lucía": true
    },
    "TAMANIQUE": {
      "Area Urbana": true,
      "Buenos Aires": true,
      "El Cuervo": true,
      "El Palmar": true,
      "El Peñon": true,
      "El Sunzal": true,
      "Juan Higinio o La Cumbre": true,
      "San Alfonso": true,
      "San Benito": true,
      "Santa Lucía": true,
      "Siberia": true,
      "Tarpeya": true
    },
    "TEOTEPEQUE": {
      "Area Urbana": true,
      "El Matazano": true,
      "El Níspero": true,
      "El Ángel": true,
      "Las Tinieblas": true,
      "Los Izotes": true,
      "San Benito": true,
      "San Isidro": true,
      "San José el Tablón": true,
      "San Marcos": true,
      "Santa María Mizata": true,
      "Sihuapilapa": true
    },
    "TEPECOYO": {
      "Area Urbana": true,
      "El Carrizo": true,
      "El Guamo": true,
      "El Mojón": true,
      "El Zacamil": true,
      "La Javia": true,
      "Las Flores": true,
      "Los Alpes": true,
      "Los Laureles": true,
      "San Antonio": true,
      "Tierra Colorada": true
    },
    "ZARAGOZA": {
      "Area Urbana": true,
      "El Barillo": true,
      "El Cimarrón": true,
      "El Riel": true,
      "Guadalupe": true,
      "Las Granadillas": true,
      "San Francisco": true,
      "San Sebastián": true
    }
  },
  "LA PAZ": {
    "CUYULTITÁN": {
      "Area Urbana": true,
      "San Antonio": true,
      "San Isidro": true
    },
    "EL ROSARIO": {
      "Amatepec": true,
      "Area Urbana": true,
      "El Cerro": true,
      "El Pedregal": true,
      "Tilapa": true
    },
    "JERUSALÉN": {
      "Area Urbana": true,
      "El Conacaste": true,
      "El Espino": true,
      "Los Romero": true,
      "San Juan Buena vista": true,
      "Veracruz": true
    },
    "MERCEDES LA CEIBA": {
      "Area Urbana": true,
      "San Antonio": true,
      "San Luís": true
    },
    "OLOCUILTA": {
      "Area Urbana": true,
      "Cupinco": true,
      "El Chilamate": true,
      "Jayuca": true,
      "Joya de Girón": true,
      "La Esperanza": true,
      "Los Guachipilines": true,
      "Planes de las Delicias": true,
      "San Antonio Girón": true,
      "San José Buenavista": true,
      "San Sebastián": true,
      "Santa Fe": true,
      "Santa Lucía Orcoyo": true,
      "Santa Lucía la Barranca": true,
      "Santo Tomás": true,
      "Valle Nuevo": true
    },
    "PARAISO DE OSORIO": {
      "Area Urbana": true,
      "El Copinol": true,
      "El Rincón": true,
      "Los Zacatales": true
    },
    "SAN ANTONIO MASAHUAT": {
      "Area Urbana": true,
      "Belén": true,
      "El Socorro": true,
      "San Antonio la Loma": true,
      "San José la Instancia": true,
      "San José los Solares": true
    },
    "SAN EMIGDIO": {
      "Area Urbana": true,
      "Concepción Lourdes": true,
      "San José Costa Rica": true
    },
    "SAN FRANCISCO CHINAMECA": {
      "Area Urbana": true,
      "Candelaria": true,
      "Concepción los Planes": true,
      "San Antonio Panchimilama": true,
      "San José la Montaña": true,
      "Santa Cruz la Vega": true
    },
    "SAN JUAN NONUALCO": {
      "Area Urbana": true,
      "El Chile": true,
      "El Golfo": true,
      "El Pajal": true,
      "El Salto": true,
      "La Laguneta": true,
      "La Longaniza": true,
      "Las Delicias": true,
      "Las Piedronas": true,
      "Los Zacatillos": true,
      "Tehuiste Abajo": true,
      "Tehuiste Arriba": true,
      "Tierra Colorada": true
    },
    "SAN JUAN TALPA": {
      "Area Urbana": true,
      "Comalapa": true,
      "Tobalón": true,
      "Veracruz": true
    },
    "SAN JUAN TEPEZONTES": {
      "Area Urbana": true,
      "La Cruz": true,
      "La Esperanza": true,
      "Los Laureles": true
    },
    "SAN LUIS LA HERRADURA": {
      "Area Urbana": true,
      "El Cordoncillo": true,
      "El Escobal": true,
      "El Llano": true,
      "El Zapote": true,
      "Guadalupe la Zorra": true,
      "La Anona": true,
      "La Calzada": true,
      "San Antonio los Blancos": true,
      "San Rafael Tasajera": true,
      "San Sebastián el Chingo": true
    },
    "SAN LUIS TALPA": {
      "Amatecampo": true,
      "Area Urbana": true,
      "Cuchilla de Comalapa": true,
      "El Pimiental": true,
      "El Porvenir": true,
      "Nuevo Edén": true,
      "San Francisco Amatepec": true,
      "Tecualuya": true,
      "Zambombera": true
    },
    "SAN MIGUEL TEPEZONTES": {
      "Area Urbana": true,
      "San Bartolo": true,
      "Soledad las Flores": true
    },
    "SAN PEDRO MASAHUAT": {
      "Area Urbana": true,
      "Barahona": true,
      "Buena Vista": true,
      "El Achiotal": true,
      "El Carmen": true,
      "El Dulce Nombre": true,
      "El Paredón": true,
      "El Porvenir": true,
      "El Sicahuite": true,
      "Las Flores": true,
      "Las Hojas": true,
      "Las Isletas": true,
      "Marcelino": true,
      "San José Luna": true,
      "Santa María la Sabana": true
    },
    "SAN PEDRO NONUALCO": {
      "Area Urbana": true,
      "El Lazareto": true,
      "El Roble": true,
      "Hacienda Vieja": true,
      "La Carbonera": true,
      "La Comunidad": true,
      "Nahuistepeque": true,
      "San Ramón": true
    },
    "SAN RAFAEL OBRAJUELO": {
      "Area Urbana": true,
      "El Carao": true,
      "La Longaniza": true,
      "La Palma": true,
      "San Jerónimo": true,
      "San José Obrajuelo": true,
      "San Miguel Obrajuelo": true,
      "San Pedro Mártir": true
    },
    "SANTA MARÍA OSTUMA": {
      "Area Urbana": true,
      "Concepción": true,
      "El Chaperno": true,
      "El Tránsito": true,
      "Loma Larga": true,
      "San Antonio": true,
      "San Isidro": true,
      "San José Carrizal": true
    },
    "SANTIAGO NONUALCO": {
      "Amulunco": true,
      "Area Urbana": true,
      "Concepción Jalponga": true,
      "El Sauce": true,
      "La Cruz del Mojón": true,
      "Las Guarumas": true,
      "Las Ánimas": true,
      "San Antonio Abajo": true,
      "San Antonio Arriba": true,
      "San Francisco Hacienda": true,
      "San Francisco el Porfiado": true,
      "San José Abajo": true,
      "San José Arriba": true,
      "San José Loma": true,
      "San José Obrajito": true,
      "San Luís Jalponguita": true,
      "San Sebastián Abajo": true,
      "San Sebastián Arriba": true,
      "Santa Cruz Chacastal": true,
      "Santa Cruz la Loma": true,
      "Santa Rita Almendro": true,
      "Santa Teresa": true
    },
    "TAPALHUACA": {
      "Area Urbana": true,
      "La Basa": true,
      "Las Lajas": true,
      "San Pedro la Palma": true
    },
    "ZACATECOLUCA": {
      "Agua Zarca": true,
      "Amayo": true,
      "Area Urbana": true,
      "Azacualpa": true,
      "Buena Vista Abajo": true,
      "Buena Vista Arriba": true,
      "El Amate": true,
      "El Callejón": true,
      "El Carmen": true,
      "El Copinol": true,
      "El Despoblado": true,
      "El Espino Abajo": true,
      "El Espino Arriba": true,
      "El Meneadero": true,
      "El Socorro": true,
      "El Zapote": true,
      "Hatos de los Reyes": true,
      "La Joya": true,
      "La Lucha": true,
      "Las Isletas": true,
      "Las Tablas": true,
      "Liévano": true,
      "Los Platanares": true,
      "Penitente Abajo": true,
      "Penitente Arriba": true,
      "Piedra Grande Abajo": true,
      "Piedra Grande Arriba": true,
      "Pineda": true,
      "San Francisco los Reyes": true,
      "San JOSÉcito": true,
      "San José la Montaña": true,
      "San Lucas": true,
      "San Marcos de la Cruz": true,
      "San Rafael": true,
      "Santa Lucía": true,
      "Tepechame": true,
      "Tierra Blanca": true,
      "Ulapa": true,
      "Ánimas Abajo": true,
      "Ánimas Arriba": true
    }
  },
  "LA UNIÓN": {
    "ANAMOROS": {
      "Agua Blanca": true,
      "Area Urbana": true,
      "Calpules": true,
      "Carbonal": true,
      "Cordoncillo": true,
      "El Cedro": true,
      "Huertas Viejas": true,
      "Talpetate": true,
      "Terreritos": true,
      "Tizate": true,
      "Tulima": true
    },
    "BOLIVAR": {
      "Albornoz": true,
      "Area Urbana": true,
      "Candelaria Albornoz": true,
      "El Tránsito": true,
      "Guadalupe": true,
      "La Paz": true,
      "La Rinconada": true,
      "Las Marías": true,
      "Los Hatillos": true,
      "Nueva Guadalupe": true,
      "Santa Lucía": true
    },
    "CONCEPCIÓN DE ORIENTE": {
      "Area Urbana": true,
      "El Guayabo": true,
      "El Molino": true,
      "El Zapote": true,
      "Guaripe": true
    },
    "CONCHAGUA": {
      "Area Urbana": true,
      "Cerro el Jiote": true,
      "Conchagüita": true,
      "El Cacao": true,
      "El Ciprés": true,
      "El Faro": true,
      "El Pilón": true,
      "Guisquil": true,
      "Los Angeles": true,
      "Maquigue": true,
      "Piedra Blanca": true,
      "Piedra Rayada": true,
      "Yologual": true
    },
    "EL CARMEN": {
      "Alto el Roble": true,
      "Area Urbana": true,
      "El Caulotillo": true,
      "El Gavilán": true,
      "El Jícaro": true,
      "El Piche": true,
      "El Tejar": true,
      "El Tihuilotal": true,
      "El Zapotal": true,
      "La Cañada": true,
      "La Quesadilla": true,
      "Las Pitas": true,
      "Los Amates": true,
      "Los Conejos": true,
      "Olomega": true,
      "Salagua": true,
      "Terrero Blanco": true
    },
    "EL SAUCE": {
      "Area Urbana": true,
      "Boquín": true,
      "Canaire": true,
      "El Algodón": true,
      "El Rincón": true,
      "El Talpetate": true,
      "Los Mojones": true,
      "San Juan Gualare": true,
      "Santa Rosita": true,
      "Talpetate": true
    },
    "INTIPUCA": {
      "Area Urbana": true,
      "Chichipate": true,
      "El Carao": true,
      "El Coyolito": true,
      "La Leona": true
    },
    "LA UNIÓN": {
      "Agua Caliente": true,
      "Agua Escondida": true,
      "Amapalita": true,
      "Area Urbana": true,
      "El Jícaro": true,
      "El Tamarindo": true,
      "Isla Chuchito": true,
      "Isla Conejo": true,
      "Isla Ilca": true,
      "Isla Martín Pérez": true,
      "Isla Perico": true,
      "Isla Periquito": true,
      "Isla Zacatillo": true,
      "La Leona": true,
      "La Quezadilla": true,
      "Las Chachas": true,
      "Llano de los Patos": true,
      "Loma Larga": true,
      "Siramá": true,
      "Tihuilotal": true
    },
    "LISLIQUE": {
      "Agua Blanca": true,
      "Agua Fría": true,
      "Area Urbana": true,
      "El Cedro": true,
      "El Derrumbado": true,
      "El Terrero": true,
      "Guajiniquil": true,
      "Higueras": true,
      "Huertas Viejas": true,
      "Las Pilas": true
    },
    "MEANGUERA DEL GOLFO": {
      "Area Urbana": true,
      "El Salvador": true,
      "Guerrero": true,
      "Isla Conchagüita": true,
      "Isla Meanguerita": true
    },
    "NUEVA ESPARTA": {
      "Agua Fría": true,
      "Area Urbana": true,
      "El Cedro": true,
      "El Portillo": true,
      "Honduritas": true,
      "Las Marías": true,
      "Mala Laja": true,
      "Monteca": true,
      "Ocotillo": true,
      "Talpetate": true
    },
    "PASAQUINA": {
      "Area Urbana": true,
      "Cerro Pelón": true,
      "El Rebalse": true,
      "El Tablón": true,
      "El Talpetate": true,
      "Horcones": true,
      "Pasaquinita": true,
      "Piedras Blancas": true,
      "San Eduardo": true,
      "San Felipe": true,
      "Santa Clara": true,
      "Valle Afuera": true
    },
    "POLOROS": {
      "Area Urbana": true,
      "Boquín": true,
      "El Carpintero": true,
      "El Guayabo": true,
      "El Pueblo": true,
      "El Rodeo": true,
      "Honduritas": true,
      "Lajitas": true,
      "Mala Laja": true,
      "Ocote": true
    },
    "SAN ALEJO": {
      "Agua Fría": true,
      "Area Urbana": true,
      "Bobadilla": true,
      "Ceibillas": true,
      "Cerco de Piedra": true,
      "El Caragón": true,
      "El Copalío": true,
      "El Tamarindo": true,
      "El Tizatillo": true,
      "Hato Nuevo": true,
      "Las Marías": true,
      "Las Queseras": true,
      "Los Amates": true,
      "Los Jiotes": true,
      "Maderas": true,
      "Mogotillo": true,
      "San Jerónimo": true,
      "Santa Cruz": true,
      "Terrero Blanco": true
    },
    "SAN JOSÉ": {
      "Area Urbana": true,
      "Chaguitillo": true,
      "El Sombrerito": true,
      "El Zapote": true,
      "La Joya": true
    },
    "SANTA ROSA DE LIMA": {
      "Area Urbana": true,
      "Candelaria Albornoz": true,
      "Copetillos": true,
      "El Algodón": true,
      "El Cordoncillo": true,
      "El Portillo": true,
      "La Chorrera": true,
      "Las Cañas": true,
      "Los Mojones": true,
      "Pasaquinita": true,
      "San Sebastián": true
    },
    "YAYANTIQUE": {
      "Area Urbana": true,
      "Centeno": true,
      "El Pastor": true,
      "El Socorro": true,
      "Los Amates": true
    },
    "YUCUAIQUÍN": {
      "Area Urbana": true,
      "Candelaria": true,
      "Ciricuario": true,
      "El Carmen": true,
      "El Tránsito": true,
      "La Cañada": true,
      "Las Cruces": true,
      "Las Marías": true,
      "Los Hatillos": true,
      "Santa Lucía": true,
      "Valle Nuevo": true
    }
  },
  "MORAZÁN": {
    "ARAMBALA": {
      "Area Urbana": true,
      "El Carrizal": true,
      "Pueblo Viejo": true,
      "Tierra Colorada": true
    },
    "CACAOPERA": {
      "Agua Blanca": true,
      "Area Urbana": true,
      "Calavera": true,
      "Guachipilín": true,
      "Junquillo": true,
      "La Estancia": true,
      "Ocotillo": true,
      "Sunsulapa": true
    },
    "CHILANGA": {
      "Area Urbana": true,
      "El Chaparral": true,
      "El Pedernal": true,
      "Joya del Matazano": true,
      "Lajitas": true,
      "Piedra Parada": true
    },
    "CORINTO": {
      "Area Urbana": true,
      "Corralito": true,
      "Hondable": true,
      "La Laguna": true,
      "San Felipe": true,
      "Varilla Negra": true
    },
    "DELICIAS DE CONCEPCIÓN": {
      "Area Urbana": true,
      "El Volcán": true,
      "La Cuchilla": true
    },
    "EL DIVISADERO": {
      "Area Urbana": true,
      "Llano de Santiago": true,
      "Loma Larga": true,
      "Loma Tendida": true,
      "Nombre de Jesús": true,
      "San Pedro Río Seco": true,
      "Santa Anita": true,
      "Villa Modelo": true
    },
    "EL ROSARIO": {
      "Area Urbana": true,
      "La Laguna": true,
      "Ojo de Agua": true
    },
    "GUALOCOCTI": {
      "Area Urbana": true,
      "La Joya": true,
      "San Lucas": true
    },
    "GUATAJIAGUA": {
      "Area Urbana": true,
      "El Sirigual": true,
      "El Volcán": true,
      "Los Abelines": true,
      "Manguera": true,
      "Pajigua": true,
      "San Bartolo": true
    },
    "JOATECA": {
      "Area Urbana": true,
      "El Zapotal": true,
      "Paturla": true,
      "Volcancillo": true
    },
    "JOCOAITIQUE": {
      "Area Urbana": true,
      "El Rodeo": true,
      "El Volcancillo": true
    },
    "JOCORO": {
      "Area Urbana": true,
      "Flamenco": true,
      "Guachipilín": true,
      "Lagunetas": true,
      "Las Marías": true,
      "Los Laureles": true,
      "San Felipe": true,
      "San José": true,
      "San Juan": true
    },
    "LOLOTIQUILLO": {
      "Area Urbana": true,
      "Gualindo": true,
      "La Manzanilla": true,
      "Sunsulapa": true
    },
    "MEANGUERA": {
      "Area Urbana": true,
      "Cerro Pando": true,
      "Guacamaya": true,
      "La Joya": true,
      "Soledad": true
    },
    "OSICALA": {
      "Agua Zarca": true,
      "Area Urbana": true,
      "Cerro Coyol": true,
      "Huilihuiste": true,
      "La Montaña": true,
      "Llano Alegre": true
    },
    "PERQUÍN": {
      "Area Urbana": true,
      "Casa Blanca": true,
      "Pueblo Viejo": true,
      "Sabanetas": true
    },
    "SAN CARLOS": {
      "Area Urbana": true,
      "La Jagua": true,
      "San Diego": true,
      "San Marcos": true,
      "Valle Nuevo": true
    },
    "SAN FERNANDO": {
      "Area Urbana": true,
      "Azacualpa": true,
      "Cañaverales": true
    },
    "SAN FRANCISCO GOTERA": {
      "Area Urbana": true,
      "Cacahuatalejo": true,
      "El Norte": true,
      "El Rosario": true,
      "El Triunfo": true,
      "San Francisquito": true,
      "San José": true
    },
    "SAN ISIDRO": {
      "Area Urbana": true,
      "El Rosario": true,
      "Piedra Parada": true
    },
    "SAN SIMÓN": {
      "Area Urbana": true,
      "El Carrizal": true,
      "El Cerro": true,
      "Las Quebradas": true,
      "Potrero Adentro": true,
      "Valle Grande": true
    },
    "SENSEMBRA": {
      "Area Urbana": true,
      "El Limón": true,
      "El Rodeo": true,
      "Loma del Chile": true
    },
    "SOCIEDAD": {
      "Area Urbana": true,
      "Calpules": true,
      "Candelaria": true,
      "El Bejucal": true,
      "El Peñón": true,
      "El Tablón": true,
      "La Joya": true,
      "Labranza": true,
      "Ánimas": true
    },
    "TOROLA": {
      "Agua Zarca": true,
      "Area Urbana": true,
      "Cerritos": true,
      "El Progreso": true,
      "Tijeretas": true
    },
    "YAMABAL": {
      "Area Urbana": true,
      "El Volcán": true,
      "La Isleta": true,
      "Loma del Chile": true,
      "San Juan de la Cruz": true
    },
    "YOLOAIQUIN": {
      "Area Urbana": true,
      "El Aceituno": true,
      "El Volcán": true
    }
  },
  "SAN MIGUEL": {
    "CAROLINA": {
      "Area Urbana": true,
      "La Ceibita": true,
      "La Orilla": true,
      "Miracapa": true,
      "Rosas Nacaspilo": true,
      "Soledad Terrero": true
    },
    "CHAPELTIQUE": {
      "Area Urbana": true,
      "Cercas de Piedra": true,
      "Gualama": true,
      "La Trinidad": true,
      "Los Amates": true,
      "San Jerónimo": true,
      "San Pedro": true
    },
    "CHINAMECA": {
      "Area Urbana": true,
      "Chambala": true,
      "Copinol Primero": true,
      "Copinol Segundo": true,
      "El Boquerón": true,
      "El Conacastal": true,
      "El Jocote": true,
      "Jocote Dulce": true,
      "La Cruz Primera": true,
      "La Cruz Segunda": true,
      "La Peña": true,
      "Las Marías": true,
      "Las Mesas": true,
      "Ojo de Agua": true,
      "Oromontique": true,
      "Planes Primero": true,
      "Planes Tercero": true,
      "San Antonio": true,
      "San Pedro Arenales": true,
      "Zaragoza": true
    },
    "CHIRILAGUA": {
      "Area Urbana": true,
      "Chilanguera": true,
      "El Capulín": true,
      "El Cuco": true,
      "Guadalupe": true,
      "Hoja de Sal": true,
      "La Estrechura": true,
      "Nueva Concepción": true,
      "San José Gualozo": true,
      "San Pedro": true,
      "Tierra Blanca": true
    },
    "CIUDAD BARRIOS": {
      "Area Urbana": true,
      "Belén": true,
      "Guanaste": true,
      "La Montañita": true,
      "Llano el Ángel": true,
      "Nuevo Porvenir": true,
      "San Cristóbal": true,
      "San Juan": true,
      "San Luisito": true,
      "San Matías": true,
      "Teponahuaste": true,
      "Torrecilla": true
    },
    "COMACARÁN": {
      "Area Urbana": true,
      "Candelaria": true,
      "El Colorado": true,
      "El Hormiguero": true,
      "El Jícaral": true,
      "Platanarillo": true
    },
    "EL TRÁNSITO": {
      "Area Urbana": true,
      "Calle Nueva": true,
      "El Cañal": true,
      "Llano del Coyol": true,
      "Moropala": true,
      "Primavera": true
    },
    "LOLOTIQUE": {
      "Amaya": true,
      "Area Urbana": true,
      "Concepción": true,
      "El Jícaro": true,
      "El Nancito": true,
      "El Palón": true,
      "Las Ventas": true,
      "San Francisco": true,
      "Santa Bárbara": true,
      "Valencia": true
    },
    "MONCAGUA": {
      "Area Urbana": true,
      "El Cerro": true,
      "El Jobo": true,
      "El Papalón": true,
      "El Platanar": true,
      "El Rodeo": true,
      "La Estancia": true,
      "La Fragua": true,
      "Los Ejidos": true,
      "Salamar": true,
      "Santa Bárbara": true,
      "Tongolona": true,
      "Valle Alegre": true
    },
    "NUEVA GUADALUPE": {
      "Area Urbana": true,
      "Los Planes de San Sebastián": true,
      "Planes Primero": true,
      "Planes Segundo": true,
      "San Luís": true
    },
    "NUEVO EDEN DE SAN JUAN": {
      "Area Urbana": true,
      "Cucurucho": true,
      "Jardín": true,
      "Laureles": true,
      "Montecillos": true,
      "Ojeo": true,
      "Queseras": true,
      "San Sebastián": true
    },
    "QUELEPA": {
      "Area Urbana": true,
      "El Obrajuelo": true,
      "El Tamboral": true,
      "San Antonio": true,
      "San José": true
    },
    "SAN ANTONIO": {
      "Area Urbana": true,
      "San Diego": true,
      "San Marcos": true
    },
    "SAN GERARDO": {
      "Area Urbana": true,
      "La Joya": true,
      "Laguna": true,
      "Quebracho": true,
      "San Jerónimo": true
    },
    "SAN JORGE": {
      "Area Urbana": true,
      "Candelaria": true,
      "Conacastal": true,
      "Joya de Ventura": true,
      "La Ceiba": true,
      "La Morita": true,
      "San Julián": true
    },
    "SAN LUIS DE LA REINA": {
      "Area Urbana": true,
      "El Junquillo": true,
      "El Ostucal": true,
      "San Antonio": true,
      "San Juan": true
    },
    "SAN MIGUEL": {
      "Altomiro": true,
      "Anchico": true,
      "Area Urbana": true,
      "Cerro Bonito": true,
      "Concepción Corozal": true,
      "El Amate": true,
      "El Brazo": true,
      "El Delirio": true,
      "El Divisadero": true,
      "El Havillal": true,
      "El Jute": true,
      "El Niño": true,
      "El Papalón": true,
      "El Progreso": true,
      "El Sitio": true,
      "El Tecomatal": true,
      "El Volcán": true,
      "Jalacatal": true,
      "La Canoa": true,
      "La Puerta": true,
      "La Trinidad": true,
      "Las Delicias": true,
      "Las Lomitas": true,
      "Mira Flores": true,
      "Monte Grande": true,
      "San Andrés": true,
      "San Antonio Chávez": true,
      "San Antonio Silva": true,
      "San Carlos": true,
      "San Jacinto": true,
      "Santa Inés": true
    },
    "SAN RAFAEL ORIENTE": {
      "Area Urbana": true,
      "Los Zelaya": true,
      "Piedra Azul": true,
      "Rodeo de Pedrón": true,
      "Santa Clara": true
    },
    "SESORI": {
      "Area Urbana": true,
      "Charlaca": true,
      "El Espíritu Santo": true,
      "El Tablón": true,
      "Las Mesas": true,
      "Managuara": true,
      "Mazatepeque": true,
      "Minitas": true,
      "Petacones": true,
      "San Jacinto": true,
      "San Sebastián": true,
      "Santa Rosa": true
    },
    "ULUAZAPA": {
      "Area Urbana": true,
      "Juan Yánez": true,
      "Los Pilones": true,
      "Río Vargas": true
    }
  },
  "SAN SALVADOR": {
    "AGUILARES": {
      "Area Urbana": true,
      "La Florida": true,
      "La Toma": true,
      "Las Tunas": true,
      "Los Mangos": true,
      "Pishishapa": true,
      "Piñalitos": true
    },
    "APOPA": {
      "Area Urbana": true,
      "El Ángel": true,
      "Guadalupe": true,
      "Joya Galana": true,
      "Joya Grande": true,
      "Las Delicias": true,
      "San Nicolás": true,
      "Santa Bárbara": true,
      "Suchinango": true,
      "Tres Ceibas": true
    },
    "AYUTUXTEPEQUE": {
      "Area Urbana": true,
      "El Zapote": true,
      "Los Llanitos": true
    },
    "CUSCATANCINGO": {
      "Area Urbana": true,
      "San Luís Mariona": true
    },
    "DELGADO": {
      "Area Urbana": true,
      "Calle Real": true,
      "El Arenal": true,
      "La Cabaña": true,
      "Plan del Pino": true,
      "San José Cortez": true,
      "San Laureano": true
    },
    "EL PAISNAL": {
      "Area Urbana": true,
      "El Jicarón": true,
      "El Matazano": true,
      "El Tronador": true,
      "La Cabaña": true,
      "Las Delicias": true,
      "Las Ventanas": true,
      "Natividad": true,
      "Potrero Grande": true,
      "San Antonio Grande": true,
      "San Diego": true,
      "San Francisco Dos Cerros": true,
      "San Rafael": true
    },
    "GUAZAPA": {
      "Area Urbana": true,
      "Calle Nueva": true,
      "Loma de Ramos": true,
      "Nance Verde": true,
      "San Cristóbal": true,
      "San Jerónimo": true,
      "San Lucas": true,
      "Santa Bárbara": true,
      "Zacamil": true
    },
    "ILOPANGO": {
      "Area Urbana": true,
      "Changallo": true,
      "Dolores Apulo": true
    },
    "MEJICANOS": {
      "Area Urbana": true,
      "Cháncala": true,
      "San Miguel": true,
      "San Roque": true,
      "Zacamil": true
    },
    "NEJAPA": {
      "Aldea Mercedes": true,
      "Area Urbana": true,
      "Camotepeque": true,
      "Conacaste": true,
      "El Bonete": true,
      "El Salitre": true,
      "Galera Quemada": true,
      "San Jerónimo los Planes": true,
      "Tutultepeque": true
    },
    "PANCHIMALCO": {
      "Amayón": true,
      "Area Urbana": true,
      "Azacualpa": true,
      "El Cedro": true,
      "El Divisadero": true,
      "El Guayabo": true,
      "Las Crucitas": true,
      "Loma y Media": true,
      "Los Pajales": true,
      "Los Palones": true,
      "Los Troncones": true,
      "Panchimalco": true,
      "Planes de Renderos": true,
      "Quezalapa": true,
      "San Isidro": true
    },
    "ROSARIO DE MORA": {
      "Area Urbana": true,
      "Cerco de Piedra": true,
      "El Carrizal": true,
      "El Jutillo": true,
      "Las Barrosas": true,
      "Las Margaritas": true,
      "Loma y Media": true,
      "Palo Grande": true,
      "Plan del Mango": true,
      "San Ramón": true
    },
    "SAN MARCOS": {
      "Ahuacatitán": true,
      "Area Urbana": true,
      "Casa de Piedra": true,
      "Cerro Amatepec": true,
      "Florencia": true,
      "Planes de Renderos": true
    },
    "SAN MARTÍN": {
      "Area Urbana": true,
      "Corinto": true,
      "El Rosario": true,
      "El Sauce": true,
      "La Flor": true,
      "La Palma": true,
      "Las Delicias": true,
      "Las Ánimas": true,
      "San José Primero": true,
      "San José Segundo": true
    },
    "SAN SALVADOR": {
      "Area Urbana": true,
      "Casa de Piedra": true,
      "Cerro Amatepec o San Jacinto": true,
      "El Carmen": true,
      "Llanitos": true,
      "Lomas de Candelaria": true,
      "Planes de Renderos": true,
      "San Isidro los planes": true
    },
    "SANTIAGO TEXACUANGOS": {
      "Area Urbana": true,
      "Asino": true,
      "El Morro": true,
      "Joya Grande": true,
      "La Cuchilla": true,
      "Shaltipa": true
    },
    "SANTO TOMAS": {
      "Area Urbana": true,
      "Caña Brava": true,
      "Chaltepe": true,
      "El Carmen": true,
      "El Ciprés": true,
      "El Guaje": true,
      "El Porvenir": true,
      "Las Casitas": true,
      "Los Palones": true,
      "Potrerillos": true
    },
    "SOYAPANGO": {
      "Area Urbana": true,
      "Buena Vista": true,
      "El Cacao": true,
      "El Guaje": true,
      "El Limón": true,
      "El Tránsito": true
    },
    "TONACATEPEQUE": {
      "Area Urbana": true,
      "Buenos Aires": true,
      "El Rosario": true,
      "El Sauce": true,
      "El Tránsito": true,
      "La Fuente": true,
      "La Unión": true,
      "Las Flores": true,
      "Malacoff": true,
      "Veracruz": true
    }
  },
  "SAN VICENTE": {
    "APASTEPEQUE": {
      "Area Urbana": true,
      "Calderas": true,
      "Cutumayo": true,
      "El Guayabo": true,
      "Las Minas": true,
      "San Felipe": true,
      "San Jacinto": true,
      "San José los Almendros": true,
      "San Juan de Merino Abajo": true,
      "San Nicolás": true,
      "San Pedro": true
    },
    "GUADALUPE": {
      "Area Urbana": true,
      "Joya de Munguía": true,
      "San Antonio los Ranchos": true,
      "San Benito": true,
      "San Emigdio el Tablón": true,
      "San Francisco Agua Agria": true,
      "San José Carbonera": true
    },
    "SAN CAYETANO ISTEPEQUE": {
      "Area Urbana": true,
      "Candelaria": true,
      "Cerro Grande": true
    },
    "SAN ESTEBAN CATARINA": {
      "Amatitán Abajo": true,
      "Amatitán Arriba": true,
      "Area Urbana": true,
      "Cerro de San Pedro": true,
      "San Esteban": true,
      "San Ildefonso": true,
      "San Jacinto la Burrera": true,
      "Santa Catarina": true
    },
    "SAN ILDEFONSO": {
      "Area Urbana": true,
      "Candelaria Lempa": true,
      "Guachipilín": true,
      "Lajas y Canoas": true,
      "San Francisco": true,
      "San Lorenzo": true,
      "San Pablo Cañales": true
    },
    "SAN LORENZO": {
      "Area Urbana": true,
      "La Cruz": true,
      "Las Ánimas": true,
      "San Francisco": true,
      "Santa Lucía": true
    },
    "SAN SEBASTIÁN": {
      "Area Urbana": true,
      "El Paraíso": true,
      "El Porvenir Aguacayo": true,
      "La Esperanza": true,
      "La Labor": true,
      "Las Rosas": true,
      "Los Laureles": true,
      "San Francisco": true,
      "Santa Cruz": true,
      "Santa Elena": true,
      "Santa Teresa": true
    },
    "SAN VICENTE": {
      "Antón Flores": true,
      "Area Urbana": true,
      "Chucuyo": true,
      "Dos Quebradas": true,
      "El Caracol": true,
      "El Marquezado": true,
      "El Rebelde": true,
      "La Soledad": true,
      "León de Piedra": true,
      "Llanos de Achichilco": true,
      "Los Laureles": true,
      "Los Pozos": true,
      "Obrajuelo Lempa": true,
      "Parras Lempa": true,
      "San Antonio Achichilquito": true,
      "San Antonio Caminos": true,
      "San Antonio tras el Cerro": true,
      "San Bartolo Ichanmico": true,
      "San Diego": true,
      "San Francisco Chamoco": true,
      "San Jacinto": true,
      "San José Río Frío": true,
      "San Juan Buena vista": true,
      "San Rafael San Diego": true,
      "Santa Gertrudis": true,
      "Volcán Opico": true
    },
    "SANTA CLARA": {
      "Agua Helada": true,
      "Area Urbana": true,
      "El Rosario": true,
      "El Tortuguero": true,
      "San Jerónimo": true,
      "San Juan de Merino": true,
      "Santa Rosa": true
    },
    "SANTO DOMINGO": {
      "Area Urbana": true,
      "El Refugio": true,
      "Izcanales": true,
      "Los Rodríguez": true,
      "Talpetates": true
    },
    "TECOLUCA": {
      "Area Urbana": true,
      "Barrio Nuevo": true,
      "El Arco": true,
      "El Campanario": true,
      "El Carao": true,
      "El Coyolito": true,
      "El Pacún": true,
      "El Palomar": true,
      "El Perical": true,
      "El Puente": true,
      "El Socorro": true,
      "La Esperanza": true,
      "Las Anonas": true,
      "Las Mesas": true,
      "San Andrés los Achiotes": true,
      "San Benito": true,
      "San Carlos": true,
      "San Fernando": true,
      "San Francisco Angulo": true,
      "San Jacinto": true,
      "San José Llano Grande": true,
      "San Nicolás Lempa": true,
      "San Ramón Grifal": true,
      "Santa Bárbara": true,
      "Santa Cruz Paraíso": true,
      "Santa Cruz el Porrillo": true
    },
    "TEPETITAN": {
      "Area Urbana": true,
      "Concepción de Cañas": true,
      "La Virgen": true,
      "Loma Alta": true
    },
    "VERAPAZ": {
      "Area Urbana": true,
      "El Carmen": true,
      "Molineros": true,
      "San Antonio Jíboa": true,
      "San Isidro": true,
      "San Jerónimo Limón": true,
      "San José Borja": true,
      "San Juan Buena vista": true,
      "San Pedro Agua Caliente": true
    }
  },
  "SANTA ANA": {
    "CANDELARIA DE LA FRONTERA": {
      "Area Urbana": true,
      "Barranquilla": true,
      "Casas de Teja": true,
      "El Chilamate": true,
      "El Jute": true,
      "El Paste": true,
      "El Zacamil": true,
      "La Criba": true,
      "La Magdalena": true,
      "La Parada": true,
      "Monte Verde": true,
      "Piedras Azules": true,
      "San Cristóbal": true,
      "San Jerónimo": true,
      "San Miguel": true,
      "San Vicente": true,
      "Santa Cruz": true,
      "Tierra Blanca": true
    },
    "CHALCHUAPA": {
      "Area Urbana": true,
      "Ayutepeque": true,
      "Buenos Aires": true,
      "El Arado": true,
      "El Coco": true,
      "El Cuje": true,
      "El Duraznillo": true,
      "El Paste": true,
      "El Tanque": true,
      "El Zacamil": true,
      "Galeano": true,
      "Guachipilín": true,
      "La Libertad": true,
      "La Magdalena": true,
      "La montañita": true,
      "Las Cruces": true,
      "Las Flores": true,
      "Los Arenales": true,
      "Los Huatales": true,
      "Ojo de Agua": true,
      "Piedra Rajada": true,
      "Porvenir Jocotillo": true,
      "San José": true,
      "San Sebastián": true
    },
    "COATEPEQUE": {
      "Area Urbana": true,
      "Caña Brava": true,
      "Conacastes": true,
      "Concepción": true,
      "El Cerro": true,
      "El Guineo": true,
      "El Jocotón": true,
      "El Junquillo": true,
      "El Pezote": true,
      "El Tinteral": true,
      "La Joya": true,
      "Las Aradas": true,
      "Nancintepeque": true,
      "Palo Negro": true,
      "Piletas": true,
      "Primavera": true,
      "Resbaladero": true,
      "San Felipe": true,
      "San Jacinto": true,
      "San José las Flores": true,
      "Siete Principes": true,
      "Solimán": true,
      "Zacatal": true
    },
    "EL CONGO": {
      "Area Urbana": true,
      "El Guineo": true,
      "El Pezote": true,
      "El Rodeo": true,
      "La Laguna": true,
      "La Presa": true,
      "Los Pinos": true,
      "Montebello": true,
      "San José las Flores": true,
      "Siete Principes": true
    },
    "EL PORVENIR": {
      "Area Urbana": true,
      "El Rosario": true,
      "Galeano": true,
      "La Magdalena": true,
      "San Cristóbal": true,
      "San Juan Chiquito": true,
      "Santa Rosa Senca": true
    },
    "MASAHUAT": {
      "Area Urbana": true,
      "Costa Rica": true,
      "El Carmen": true,
      "El Jute": true,
      "Honduritas": true,
      "La Joya": true,
      "La Ruda": true,
      "Laguna Seca": true,
      "San Sebastián": true
    },
    "METAPÁN": {
      "Aldea Zapote": true,
      "Area Urbana": true,
      "Belén Guijat": true,
      "Cañas Dulces": true,
      "Cuyuiscat": true,
      "El Brujo": true,
      "El Capulín": true,
      "El Carmen": true,
      "El Carrizalillo": true,
      "El Limo": true,
      "El Panal": true,
      "El Rosario": true,
      "El Shiste": true,
      "La Ceibita": true,
      "La Isla": true,
      "La Joya": true,
      "Lagunetas": true,
      "Las Pavas": true,
      "Las Piedras": true,
      "Llano de la Virgen": true,
      "Mal Paso": true,
      "Matalapa": true,
      "Montenegro": true,
      "Ostúa": true,
      "San Antonio Masahuat": true,
      "San Antonio la Junta": true,
      "San Jerónimo": true,
      "San José Camulian": true,
      "San José Ingenio": true,
      "San Juan las Minas": true,
      "San Miguel Ingenio": true,
      "San Sebastián": true,
      "Santa Rita": true,
      "Santo Tomás": true,
      "Tahuilapa": true,
      "Tecomapa": true
    },
    "SAN ANTONIO PAJONAL": {
      "Area Urbana": true,
      "Belén Guijat": true,
      "El Barrial": true,
      "El Tablón": true,
      "El mojón": true,
      "El Ángel": true,
      "La Danta": true,
      "La Piedrona": true,
      "Las Pilas": true,
      "San Cayetano": true,
      "San Miguel": true
    },
    "SAN SEBASTIÁN SALITRILLO": {
      "Area Urbana": true,
      "Los Amates": true,
      "Monte Largo": true,
      "San José": true,
      "San Luís": true,
      "Santa Bárbara": true,
      "Santa Rosa": true
    },
    "SANTA ANA": {
      "Area Urbana": true,
      "Ayuta": true,
      "Ayutepeque": true,
      "Buenos Aires": true,
      "Calzontes Abajo": true,
      "Calzontes Arriba": true,
      "Cantarrana": true,
      "Chilcuyo": true,
      "Chupaderos": true,
      "Comecayo": true,
      "Cujucuyo": true,
      "Cutumay Camones": true,
      "El Jute": true,
      "El Portezuelo": true,
      "Flor Amarilla Abajo": true,
      "Flor Amarilla Arriba": true,
      "La Empalizada": true,
      "La Montañita": true,
      "La Parada": true,
      "Las Aradas": true,
      "Loma Alta": true,
      "Lomas de San Marcelino": true,
      "Los Amates": true,
      "Los Apoyos": true,
      "Monte Largo": true,
      "Nancintepeque": true,
      "Natividad": true,
      "Ochupse Abajo": true,
      "Ochupse Arriba": true,
      "Palo de Campana": true,
      "Pinalito": true,
      "Pinalón": true,
      "Planes de la Laguna": true,
      "Potrerillos Abajo de la Laguna": true,
      "Potrerillos de la Laguna": true,
      "Potrerillos del Matazano": true,
      "Potrero Grande Abajo": true,
      "Potrero Grande Arriba": true,
      "Primavera": true,
      "Ranchador": true,
      "San Juan Buena Vista": true,
      "Tablón del Matazano": true,
      "Valle del Matazano": true
    },
    "SANTA ROSA GUACHIPILÍN": {
      "Area Urbana": true,
      "El Despoblado": true,
      "El Matazano": true,
      "Las Piedras": true,
      "Llano de Las Majadas": true,
      "Palo Galán": true,
      "San Francisco Apanta": true,
      "San José Capulín": true,
      "Santa Rita Cimarrón": true,
      "Sunapa": true
    },
    "SANTIAGO DE LA FRONTERA": {
      "Area Urbana": true,
      "Barranquilla": true,
      "Chilamates": true,
      "El Flor": true,
      "Guacamayas": true,
      "La Danta": true,
      "Las Piletas": true,
      "Piedras Azules": true,
      "San Cayetano": true,
      "San Vicente": true,
      "Santa Cruz": true
    },
    "TEXISTEPEQUE": {
      "Area Urbana": true,
      "Chilcuyo": true,
      "Costa Rica": true,
      "Cujucuyo": true,
      "El Jute": true,
      "Pinalón": true,
      "San Antonio Masahuat": true,
      "San Jerónimo": true,
      "San Miguel": true,
      "Santo Tomás": true
    }
  },
  "SONSONATE": {
    "ACAJUTLA": {
      "Area Urbana": true,
      "El Coyol": true,
      "El Salamo": true,
      "El Suncita": true,
      "Metalío": true,
      "Morro Grande": true,
      "Punta Remedios": true,
      "San Julián": true,
      "Valle Nuevo": true
    },
    "ARMENIA": {
      "Area Urbana": true,
      "Azacualpa": true,
      "El Cerro": true,
      "El Guayabo": true,
      "El Rosario": true,
      "La Puerta": true,
      "Las Crucitas": true,
      "Los Mangos": true,
      "Tres Ceibas": true,
      "Valle Nuevo": true
    },
    "CALUCO": {
      "Agua Caliente": true,
      "Area Urbana": true,
      "Cerro Alto": true,
      "El Castaño": true,
      "El Zapote": true,
      "Las Flores": true,
      "Los Gramales": true,
      "Plan de Amayo": true,
      "Suquiat": true
    },
    "CUISNAHUAT": {
      "Agua Shuca": true,
      "Apancoyo": true,
      "Area Urbana": true,
      "Chiquihuat": true,
      "Coquiama": true,
      "El Achiotal": true,
      "El Bálsamar": true,
      "Los Dos Rios": true,
      "Salinas De Ayacachapa": true,
      "San Lucas": true
    },
    "IZALCO": {
      "Area Urbana": true,
      "Cangrejera": true,
      "Ceiba del Charco": true,
      "Chorro Abajo": true,
      "Chorro Arriba": true,
      "Cruz Grande": true,
      "Cuntan": true,
      "Cuyagualo": true,
      "El Sunza": true,
      "Huiscoyolate": true,
      "Joya de Cerén": true,
      "La Chapina": true,
      "Las Higueras": true,
      "Las Lajas": true,
      "Las Marías": true,
      "Piedras Pachas": true,
      "Quebrada Española": true,
      "San Isidro": true,
      "Shon Shon": true,
      "Talcomunca": true,
      "Tapalshucut": true,
      "Tecuma": true,
      "Teshcal": true,
      "Tres Ceibas": true,
      "Tunalmiles": true
    },
    "JUAYUA": {
      "Area Urbana": true,
      "Buenos Aires": true,
      "La Puente": true,
      "La Unión": true,
      "Los Apantes": true,
      "Los Cañales": true,
      "Los Naranjos": true,
      "Ojo de Agua": true,
      "San José la Majada": true,
      "San Juan de Dios": true,
      "Valle Nuevo": true
    },
    "NAHUIZALCO": {
      "Anal Abajo": true,
      "Anal Arriba": true,
      "Area Urbana": true,
      "Cusamaluco": true,
      "El Canelo": true,
      "El Carrizal": true,
      "El Cerrito": true,
      "El Chaparrón": true,
      "La Guacamaya": true,
      "Loma del Muerto": true,
      "Los Apantes": true,
      "Los Arenales": true,
      "Pushtán": true,
      "Sabana Grande": true,
      "Sabana San Juan Abajo": true,
      "Sabana San Juan Arriba": true,
      "Sisimitepec": true,
      "Tajcuilujlan": true
    },
    "NAHULINGO": {
      "Alemán": true,
      "Area Urbana": true,
      "Conacaste Herrado": true,
      "El Guayabo": true,
      "Piedra de Moler": true
    },
    "SALCOATITAN": {
      "Area Urbana": true,
      "El Puente": true,
      "Los Anizales": true
    },
    "SAN ANTONIO DEL MONTE": {
      "Agua Santa": true,
      "Area Urbana": true,
      "Cuyuapa Abajo": true,
      "Cuyuapa Arriba": true,
      "El Castaño": true,
      "Las Hojas": true,
      "San Ramón": true
    },
    "SAN JULIÁN": {
      "Agua Shuca": true,
      "Area Urbana": true,
      "Chilata": true,
      "El Achiotal": true,
      "El Bebedero": true,
      "Los Lagartos": true,
      "Palo Verde": true,
      "Petacas": true,
      "Peña Blanca": true,
      "San Julián": true,
      "Tierra Colorada": true
    },
    "SANTA CATARINA MASAHUAT": {
      "Area Urbana": true,
      "Cuyuapa": true,
      "Cuyuapa Arriba": true,
      "El Matazano": true,
      "Las Peñas": true,
      "San Rafael": true
    },
    "SANTA ISABEL ISHUATÁN": {
      "Acachapa": true,
      "Apancoyo": true,
      "Area Urbana": true,
      "Atiluya": true,
      "El Corozal": true,
      "El Paraíso": true,
      "Las Piedras": true,
      "Miramar": true,
      "Paso de Canoas": true,
      "Salinas De Ayacachapa": true
    },
    "SANTO DOMINGO DE GUZMÁN": {
      "Area Urbana": true,
      "El Carrizal": true,
      "El Caulote": true,
      "El Zarzal": true,
      "El Zope": true
    },
    "SONSONATE": {
      "Area Urbana": true,
      "Chiquihuat": true,
      "El Cacao": true,
      "El Edén": true,
      "El Presidio": true,
      "La Ensenada": true,
      "Las Delicias": true,
      "Las Tablas": true,
      "Loma del Muerto": true,
      "Miralvalle": true,
      "Salinas de Ayacachapa": true,
      "San Julián": true,
      "Santa Emilia": true,
      "Tonalá": true
    },
    "SONZACATE": {
      "Area Urbana": true,
      "El Almendro": true
    }
  },
  "USULUTÁN": {
    "ALEGRIA": {
      "Apastepeque": true,
      "Area Urbana": true,
      "El Quebacho": true,
      "La Peña": true,
      "Las Casitas": true,
      "San José la Montañita": true,
      "San Juan": true,
      "Yomo": true,
      "Zapotillo": true
    },
    "BERLÍN": {
      "Area Urbana": true,
      "Colón": true,
      "Concepción": true,
      "El Corozal": true,
      "El Tablón": true,
      "La Unión": true,
      "Las Delicias": true,
      "Las Piletas": true,
      "Los Talpetates": true,
      "San Felipe": true,
      "San Francisco": true,
      "San Isidro": true,
      "San José": true,
      "San Juan Loma Alta": true,
      "San Lorenzo": true,
      "Santa Cruz": true,
      "Virginia": true
    },
    "CALIFORNIA": {
      "Area Urbana": true,
      "El Nísperal": true,
      "El Pozón": true,
      "El Tigre": true,
      "El Volcán": true
    },
    "CONCEPCIÓN BATRES": {
      "Area Urbana": true,
      "El Cañal": true,
      "El Paraisal": true,
      "El Porvenir": true,
      "Hacienda Nueva": true,
      "La Anchila": true,
      "La Danta": true,
      "Los Desmontes": true,
      "San Antonio": true,
      "San Felipe": true,
      "San Ildefonso": true
    },
    "EL TRIUNFO": {
      "Area Urbana": true,
      "El Jícarito": true,
      "El Palón": true,
      "La Palmera": true,
      "San Antonio": true
    },
    "EREGUAYQUÍN": {
      "Analco": true,
      "Area Urbana": true,
      "El Maculis": true,
      "La Ceiba": true,
      "Los Encuentros": true,
      "Piedra Ancha": true
    },
    "ESTANZUELAS": {
      "Area Urbana": true,
      "Condadillo": true,
      "El Caragual": true,
      "El Escarbadero": true,
      "El Ojushte": true,
      "El Tecomatal": true,
      "La Cruz": true,
      "San Pedro": true,
      "Sitio San Antonio": true
    },
    "JIQUILISCO": {
      "Aguacayo": true,
      "Area Urbana": true,
      "Bolívar": true,
      "Cabos Negros": true,
      "California": true,
      "Ceiba Gacha": true,
      "El Carmen": true,
      "El Carrizal": true,
      "El Castaño": true,
      "El Coyolito": true,
      "El Marillo": true,
      "El Paraíso": true,
      "El Roquinte": true,
      "Hule Chacho": true,
      "Isla de Méndez": true,
      "La Canoa": true,
      "La Concordia": true,
      "La Cruzadilla de San Juan": true,
      "La Montaña": true,
      "La Nuria": true,
      "La Tirana": true,
      "Las Delicias": true,
      "Las Flores": true,
      "Las Mesitas": true,
      "Los Campos": true,
      "Los Limones": true,
      "Los Planes": true,
      "Los Tres Chorros": true,
      "Puertos los Ávalos": true,
      "Salinas de Sisiguayo": true,
      "Salinas el Potrero": true,
      "San Antonio Potrerillos": true,
      "San José o la Carrera": true,
      "San Juan de Letrán": true,
      "San Juan del Gozo": true,
      "San Judas": true,
      "San Marcos Lempa": true,
      "San Pedro": true,
      "Taburete Jagual": true,
      "Taburete los Claros": true,
      "Tierra Blanca o Nueva Esperanza": true,
      "Zamorán": true
    },
    "JUCUAPA": {
      "Area Urbana": true,
      "El Amatón": true,
      "El Chagüite": true,
      "El Níspero": true,
      "Llano Grande de las Piedras": true,
      "Llano el Chilamate": true,
      "Loma de la Cruz": true,
      "Tapesquillo Alto": true,
      "Tapesquillo Bajo": true
    },
    "JUCUARÁN": {
      "Area Urbana": true,
      "El Jutal": true,
      "El Jícaro": true,
      "El Llano": true,
      "El Progreso": true,
      "El Zapote": true,
      "La Cruz": true,
      "Samuria": true
    },
    "MERCEDES UMAÑA": {
      "Area Urbana": true,
      "El Caragual": true,
      "El Caulote": true,
      "El Jocotillo": true,
      "El Jícaro": true,
      "La Montañita": true,
      "La Puerta": true,
      "Los Horcones": true,
      "Los Talnetes": true,
      "San Benito": true,
      "Santa Anita": true
    },
    "NUEVA GRANADA": {
      "Area Urbana": true,
      "Azacualpía de Gualcho": true,
      "Azacualpía de Joco": true,
      "El Amatillo": true,
      "Jocomontique": true,
      "La Isleta": true,
      "La Palomia": true,
      "Las Llaves": true,
      "Lepaz": true,
      "Nuevo Carrizal": true,
      "Potrero de Joco": true,
      "San José": true
    },
    "OZATLÁN": {
      "Area Urbana": true,
      "El Delirio": true,
      "El Palmital": true,
      "Joya del Pilar": true,
      "La Breña": true,
      "La Poza": true,
      "Las Trancas": true,
      "Paso De Gualache": true,
      "San José o La Carrera": true
    },
    "PUERTO EL TRIUNFO": {
      "Area Urbana": true,
      "Ceiba Doblada": true,
      "Chaguantique": true,
      "Corral de Mulas": true,
      "El Espíritu Santo": true,
      "El Sitio Santa Lucía": true,
      "Madresal": true
    },
    "SAN AGUSTÍN": {
      "Area Urbana": true,
      "Buenos Aires": true,
      "El Cedro": true,
      "El Corozo": true,
      "El Jocote": true,
      "El Jícaro": true,
      "El Rodeo": true,
      "Eucaliptos": true,
      "Galingagua": true,
      "Jobal Arrozales": true,
      "La Ceiba": true,
      "La Mora": true,
      "La Quesera": true,
      "Las Delicias": true,
      "Linares Caulotal": true,
      "Los Arrozales": true,
      "Los Planes": true,
      "Nombre de Dios": true,
      "Tres Calles": true
    },
    "SAN BUENAVENTURA": {
      "Area Urbana": true,
      "El Aceituno": true,
      "El Semillero": true,
      "La Caridad": true,
      "La Tronconada": true,
      "Las Charcas": true,
      "Llano el Chilamate": true,
      "Los Espinos": true
    },
    "SAN DIONISIO": {
      "Area Urbana": true,
      "Iglesia Vieja": true,
      "Mundo Nuevo": true
    },
    "SAN FRANCISCO JAVIER": {
      "Area Urbana": true,
      "El Tablón": true,
      "El Zúngano": true,
      "Jobal Hornos": true,
      "La Cruz": true,
      "La Peña": true,
      "Los Horcones": true,
      "Los Hornos": true,
      "Los Ríos": true
    },
    "SANTA ELENA": {
      "Area Urbana": true,
      "El Amate": true,
      "El Nanzal": true,
      "El Nísperal": true,
      "El Rebalse": true,
      "El Volcán": true,
      "Joya Ancha Abajo": true,
      "Joya Ancha Arriba": true,
      "Las Cruces": true,
      "Piedra de Agua": true,
      "Plan Grande": true
    },
    "SANTA MARÍA": {
      "Area Urbana": true,
      "El Obrajuelo": true,
      "La Ceiba": true,
      "Mejicapa": true,
      "San Francisco": true
    },
    "SANTIAGO DE MARÍA": {
      "Area Urbana": true,
      "Batres": true,
      "El Marquezado": true,
      "El Tigre": true,
      "Las Flores": true,
      "Las Playitas": true,
      "Llano Grande de las Piedras": true,
      "Loma de la Cruz": true,
      "Loma de los Gonzáles": true
    },
    "TECAPAN": {
      "Area Urbana": true,
      "Cerro Verde": true,
      "El Jícaro": true,
      "Los Chapetones": true,
      "Los Horcones": true,
      "Paso de Gualache": true
    },
    "USULUTAN": {
      "Area Urbana": true,
      "Capitán Lazo": true,
      "El Cerrito": true,
      "El Ojushte": true,
      "El Trillo": true,
      "La Joya de Tomasito": true,
      "La Laguna": true,
      "La Peña": true,
      "La Presa": true,
      "Las Salinas": true,
      "Las Trancas": true,
      "Los Desmontes": true,
      "Obrajuelo": true,
      "Ojo de Agua": true,
      "Palo Galán": true,
      "San Francisco": true,
      "Santa Bárbara": true,
      "Talpetate": true
    }
  }
},
startFields: function () {
            document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').addEventListener("change", customCodFormProvinces.onProvinceChange);
            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').addEventListener("change", customCodFormProvinces.onCityChange);
        },
        onProvinceChange: function () {
            var value = document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').value;

            var html = "";

            if (!customCodFormProvinces.data[value]) {
                html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value = "";
                customCodFormProvinces.onCityChange();
                return;
            }

            html += '<option value="">' + _COD_FORM_CITY_LABEL + '</option>';

            Object.keys(customCodFormProvinces.data[value]).sort().forEach(function (item) {
                html += '<option value="' + item + '">' + item + '</option>';
            });

            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').innerHTML = html;
            document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value = "";
            customCodFormProvinces.onCityChange();
        },
        onCityChange: function () {
            var provValue = document.querySelector('#_rsi-cod-form-modal [data-type="province_country_field"]').value;
            var value = document.querySelector('#_rsi-cod-form-modal [data-type="city_country_field"]').value;

            var html = "";

            if (!customCodFormProvinces.data[provValue]) {
                html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
                return;
            }

            if (!customCodFormProvinces.data[provValue][value]) {
                html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
                document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
                return;
            }

            html += '<option value="">' + _COD_FORM_ZIP_LABEL + '</option>';

            Object.keys(customCodFormProvinces.data[provValue][value]).sort().forEach(function (item) {
                html += '<option value="' + item + '">' + item + '</option>';
            });

            document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').innerHTML = html;
            document.querySelector('#_rsi-cod-form-modal [data-type="civic_number_country_field"]').value = "";
        }
    };

    function _COD_FORM_ON_OPEN_INIT_END_DEF() {
        customCodFormProvinces.startFields();
    }

    var _COD_FORM_CITY_LABEL = "";
    var _COD_FORM_ZIP_LABEL = "";

    function _COD_FORM_OVERWRITE_INIT() {

        _rsi.s.form.fields.items_array.forEach(function (item) {
            if (item.type == "province_country_field" || item.type == "province") {
                item.type = "province_country_field";
                item.backendFields.name = "province_country_field";
                item.backendFields.elementType = "select";
                var options = [];
                Object.keys(customCodFormProvinces.data).sort().forEach(function (i) {
                  options.push({
                      value: i, label: i
                  });
              });
                item.backendFields.options = options;
            } else if (item.type == "city") {
                item.type = "city_country_field";
                item.backendFields.name = "city";
                item.backendFields.elementType = "select";
                _COD_FORM_CITY_LABEL = item.n.ph;
                var options = [{
                    value: "", label: _COD_FORM_CITY_LABEL
                }];
                item.backendFields.options = options;
            } else if (item.type == "civic_number") {
                item.type = "civic_number_country_field";
                item.backendFields.name = "civic_number";
                item.backendFields.elementType = "select";
                _COD_FORM_ZIP_LABEL = item.n.ph;
                var options = [{
                    value: "", label: _COD_FORM_ZIP_LABEL
                }];
                item.backendFields.options = options;
            }
        });

        return true;
    }